import type { JSX } from 'react';
import React from 'react';

import { Skeleton } from '@feathr/components';

interface IProps {
  height?: number;
}

function AudienceAreaChartSkeleton({ height }: Readonly<IProps>): JSX.Element {
  return (
    <>
      <Skeleton paragraphs={2} width={'20%'} />
      <Skeleton height={height ?? 175} width={'100%'} />
      <Skeleton paragraphs={1} />
    </>
  );
}

export default AudienceAreaChartSkeleton;
